import { PlannerEmployee } from "@/components/appointmentRequest/assignmentPlanner/assignmentPlan";

const collator = new Intl.Collator("de", {
  sensitivity: "base",
  numeric: true,
});
const normalize = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/,/g, " ")
    .toLocaleLowerCase("de");
export function filterPlannerEmployees(
  employees: PlannerEmployee[],
  search: string,
  departmentIds: string[],
) {
  const terms = normalize(search).trim().split(/\s+/).filter(Boolean);
  return employees
    .filter((employee) => {
      const text = normalize(
        [
          employee.name,
          employee.first_name,
          employee.last_name,
          employee.email,
          employee.worker_id,
        ]
          .filter(Boolean)
          .join(" "),
      );
      return (
        terms.every((term) => text.includes(term)) &&
        (!departmentIds.length ||
          employee.departments?.some((department) =>
            departmentIds.includes(department.id),
          ))
      );
    })
    .sort(
      (left, right) =>
        collator.compare(
          left.last_name ?? left.name,
          right.last_name ?? right.name,
        ) ||
        collator.compare(left.first_name ?? "", right.first_name ?? "") ||
        collator.compare(left.name, right.name) ||
        left.id.localeCompare(right.id),
    );
}
export function duplicatePlannerEmployeeIds(employees: PlannerEmployee[]) {
  const groups = new Map<string, PlannerEmployee[]>();
  for (const employee of employees) {
    const name = employee.name
      .trim()
      .replace(/\s+/g, " ")
      .toLocaleLowerCase("de");
    const group = groups.get(name);
    if (group) group.push(employee);
    else groups.set(name, [employee]);
  }
  return new Set(
    [...groups.values()]
      .filter((group) => group.length > 1)
      .flatMap((group) => group.map((employee) => employee.id)),
  );
}
export function plannerDepartments(employees: PlannerEmployee[]) {
  return [
    ...new Map(
      employees
        .flatMap((employee) => employee.departments ?? [])
        .map((department) => [department.id, department]),
    ).values(),
  ].sort((left, right) => collator.compare(left.name, right.name));
}
